import { spacing } from './ui/types'

/**
 * Rendered in place of a WebGL map when the browser has no working WebGL
 * context (headless, GPU blocklisted, or Chrome blocked the page after a prior
 * context loss). Offers an OpenStreetMap link when coordinates are known.
 */
export default function MapUnavailable({
  latitude,
  longitude,
}: {
  latitude?: number
  longitude?: number
}) {
  const hasCoords =
    typeof latitude === 'number' &&
    typeof longitude === 'number' &&
    (latitude !== 0 || longitude !== 0)
  const href = hasCoords
    ? `https://www.openstreetmap.org/?mlat=${latitude}&mlon=${longitude}#map=15/${latitude}/${longitude}`
    : undefined
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: spacing.sm,
        padding: spacing.lg,
        textAlign: 'center',
        background: 'var(--surface-sunken)',
        color: 'var(--ink-1)',
        fontSize: 14,
      }}
    >
      <div style={{ fontWeight: 600 }}>Carte indisponible</div>
      <div style={{ color: 'var(--ink-2)' }}>
        Votre navigateur n'a pas pu initialiser la carte.
      </div>
      {href && (
        <a href={href} target="_blank" rel="noreferrer">
          Voir sur OpenStreetMap
        </a>
      )}
    </div>
  )
}
